import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return (
      detail
        .map((e) => (e && typeof e.msg === "string" ? e.msg : ""))
        .filter(Boolean)
        .join(" ") || "Please check your details and try again."
    );
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
